var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPuertaAbierta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#040006;}.cls-3{fill:#278257;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-puerta-abierta") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_32",
    "data-name": 32
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.23,101.82a6.21,6.21,0,0,1,6.2,6.2v64.35a6.21,6.21,0,0,1-6.2,6.21H76a6.21,6.21,0,0,1-6.2-6.21V108a6.21,6.21,0,0,1,6.2-6.2h77.22M114.62,50.11A32.19,32.19,0,0,0,82.45,82.29H94.67a19.95,19.95,0,1,1,39.9,0V95.16H76A12.91,12.91,0,0,0,63.14,108v64.35A12.91,12.91,0,0,0,76,185.24h77.22a12.91,12.91,0,0,0,12.87-12.87V108a12.9,12.9,0,0,0-12.87-12.86H146.8V82.29a32.2,32.2,0,0,0-32.18-32.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.62,126.22a14,14,0,1,0,14,14A14,14,0,0,0,114.62,126.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPuertaAbierta);
export default __webpack_public_path__ + "static/media/ic-puerta-abierta.2da29f2bc18b41f212dc21d4e50fa6d1.svg";
export { ForwardRef as ReactComponent };